import * as React from 'react';

function Archery(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M18 3a.75.75 0 01.745.662l.005.088v.544l.813-.813a.75.75 0 011.123.99l-.063.07-.708.709h.335a.75.75 0 01.088 1.494l-.088.005h-.939A8.959 8.959 0 0121 12c0 2.31-.87 4.417-2.302 6.011l1.52 1.52.062.07a.75.75 0 01-1.123.99l-1.551-1.55A8.962 8.962 0 0112 20.998c-2.216 0-4.245-.801-5.813-2.13l-.03.035-1.875 1.875a.75.75 0 01-1.124-.99l.063-.07 1.874-1.875.035-.031A9 9 0 0117.25 4.69v-.94A.75.75 0 0118 3zm-6 1.5a7.499 7.499 0 105.855 2.812L16.786 8.38a5.999 5.999 0 11-1.048-1.075l1.067-1.065A7.47 7.47 0 0012 4.5zm0 3a4.5 4.5 0 103.712 1.954l-1.088 1.088a2.999 2.999 0 11-1.034-1.087l1.08-1.08A4.48 4.48 0 0012 7.5zm0 2.999a1.5 1.5 0 101.47 1.197l-.887.886a.75.75 0 01-1.123-.99l.063-.07.947-.948a1.498 1.498 0 00-.47-.075z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Archery;
